import { Component, inject } from '@angular/core';
import { MatCardContent } from "@angular/material/card";
import { TranslatePipe } from '@ngx-translate/core';
import { ParamCursoDataService } from '../../../../../../services/curso/param-curso-data.service';

@Component({
  selector: 'app-termo-nao-aceito',
  imports: [
    MatCardContent,
    TranslatePipe
  ],
  templateUrl: './termo-nao-aceito.html',
  styleUrl: './termo-nao-aceito.css'
})
export class TermoNaoAceito {

  _paramData = inject(ParamCursoDataService)

  get nome () {
    return this._paramData.getDataSubmit().pessoa.PF_NOME;
  }

  get nome_curso () {
    return this._paramData.NomeCurso;
  }

}
